import React, { useContext } from 'react';
import { Menu, MenuItem } from '@mui/material';
import { Link } from 'react-router-dom';
import AuthService from 'services/auth';
import UserContext from 'shared/contexts/UserContext';
import { ROUTES } from 'shared/routes';

interface Props {
  anchorEl: any;
  handleClose: () => void;
  open: boolean;
}

const HeaderMenu: React.FC<Props> = (
  { anchorEl, handleClose, open }: Props,
) => {
  const [userState, userDispatch] = useContext(UserContext);
  const { person } = userState;

  const signOut = async () => {
    try {
      userDispatch({ type: 'logout' });
      await AuthService.signOut();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('error signing out: ', error);
    }
  };

  return (
    <Menu
      id="header-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      onClick={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <MenuItem component={Link} to={`${ROUTES.people}/${person.slug}`}>
        My Profile
      </MenuItem>
      <MenuItem onClick={signOut} id="header-sign-out">
        Sign Out
      </MenuItem>
    </Menu>
  );
};

export default HeaderMenu;
